"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var kinsideTokens_1 = require("../kinsideTokens");
var lodash_1 = require("lodash");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        inputLabel: {
            display: "block",
            position: "unset",
            marginBottom: theme.spacing(1),
            transform: "unset",
            transition: "unset",
        },
        chip: {
            backgroundColor: kinsideTokens_1.kinsideTokens["--gray-10"],
            borderRadius: theme.spacing(2),
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5),
            marginTop: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        chipContainer: {
            display: "flex",
            flexWrap: "wrap",
        },
        formControl: {
            width: "100%",
        },
    });
});
var MultiSelect = function (props) {
    var _a, _b;
    var classes = useStyles();
    var _c = react_1.useState(false), menuOpen = _c[0], setMenuOpen = _c[1];
    var handleSelectChange = function (event) {
        var value = event.target.value;
        props.onSelectionChange(typeof value === "string" ? value.split(",") : value);
    };
    var removeItem = function (id) {
        props.onSelectionChange(props.selectedItemIds.filter(function (itemId) { return itemId !== id; }));
    };
    var isItemSelected = function (id) { return props.selectedItemIds.includes(id); };
    var selectId = lodash_1.uniqueId("multi-select-");
    return (react_1.default.createElement(core_1.FormControl, { error: !!((_a = props.error) === null || _a === void 0 ? void 0 : _a.text), className: classes.formControl },
        props.label && (react_1.default.createElement(core_1.InputLabel, { id: selectId + "-label", className: classes.inputLabel }, props.label)),
        react_1.default.createElement(core_1.Select, { labelId: selectId + "-label", id: selectId, multiple: true, margin: "dense", variant: "outlined", fullWidth: true, open: menuOpen, onClose: function () { return setMenuOpen(false); }, onOpen: function () { return setMenuOpen(true); }, value: props.selectedItemIds, onChange: handleSelectChange, renderValue: function () { return props.selectedItemIds.length + " selected"; } }, props.items.map(function (item) {
            var isSelected = isItemSelected(item.id);
            var style = isSelected ? { fontWeight: 500 } : {};
            return (react_1.default.createElement(core_1.MenuItem, { key: item.id, value: item.id, style: style },
                isSelected && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleCheck, className: "mr-1", style: style, "aria-hidden": "true" })),
                item.label));
        })),
        react_1.default.createElement("div", { className: classes.chipContainer }, props.selectedItemIds.map(function (itemId) {
            var item = props.items.find(function (i) { return i.id === itemId; });
            return (react_1.default.createElement(core_1.Chip, { key: itemId, label: item === null || item === void 0 ? void 0 : item.label, onDelete: function () { return removeItem(itemId); }, className: classes.chip, "aria-label": "Selected: " + (item === null || item === void 0 ? void 0 : item.label) }));
        })),
        !!((_b = props.error) === null || _b === void 0 ? void 0 : _b.text) && (react_1.default.createElement(core_1.FormHelperText, null, props.error.text))));
};
exports.MultiSelect = MultiSelect;
